import { UrlParams } from '@/common/enums';
import { getUrlParam } from '@/common/utils';

export function truncateString(input: string | number | null, maxLength: number): string {
    if (input === null) {
        return '';
    }

    if (typeof input === 'number') {
        input = input.toString();
        if (input.length > maxLength) {
            input = input.slice(0, maxLength);
        }
    }

    if (input.length > maxLength) {
        return input.slice(0, maxLength - 3) + '...';
    }
    return input;
}

export const formatEventTime = (time: string, isPlusSignNeeded: boolean): string => {
  const numTime = Number(time);
  if (isNaN(numTime)) return time;
  if (!isPlusSignNeeded) return time;

  if (numTime > 120) {
      return `120+${numTime - 120}`;
  } else if (numTime > 90) {
      return `90+${numTime - 90}`;
  } else if (numTime > 45) {
      return `45+${numTime - 45}`;
  }
  return time;
}

export { getUrlParam };

//function to preict and generate fucntion from data used in Circle component to predict angle from x and y for rect
// the code is here for future use, please do not delete it
  // type DataPoint = [number, number, number]; // [x, y, z]

  // function createPredictionFunction(data: DataPoint[]): ((x: number, y: number) => number) | string {
  //   // Calculate means
  //   const n = data.length;
  //   const meanX = data.reduce((sum, [x]) => sum + x, 0) / n;
  //   const meanY = data.reduce((sum, [, y]) => sum + y, 0) / n;
  //   const meanZ = data.reduce((sum, [, , z]) => sum + z, 0) / n;
  
  //   // Calculate coefficients
  //   let xxSum = 0, xySum = 0, xzSum = 0, yySum = 0, yzSum = 0;
  //   for (const [x, y, z] of data) {
  //     xxSum += (x - meanX) ** 2;
  //     xySum += (x - meanX) * (y - meanY);
  //     xzSum += (x - meanX) * (z - meanZ);
  //     yySum += (y - meanY) ** 2;
  //     yzSum += (y - meanY) * (z - meanZ);
  //   }
  
  //   const denominator = xxSum * yySum - xySum ** 2;
  //   const a = (yySum * xzSum - xySum * yzSum) / denominator;
  //   const b = (xxSum * yzSum - xySum * xzSum) / denominator;
  //   const c = meanZ - a * meanX - b * meanY;
  
  //   // Return the prediction function
  //   // return (x: number, y: number) => a * x + b * y + c;
  //   return `z = ${a.toFixed(4)} * x + ${b.toFixed(4)} * y + ${c.toFixed(4)}`;
  // }
  
  // Example usage:
  // const data: DataPoint[] = [
  //   [46, 74, 18],
  //   [42, 67, 25],
  //   [36, 57, 35],
  //   [90, 145, -55],
  //   [51, 82, 10],
  //   [57, 91, 0],
  //   [65, 104, -10],
  //   [7, 13, 80],
  //   [57, 91, 0],
  //   [85, 136, -46],
  //   [99, 158, -65]
  // ];

  // const data2: DataPoint[] = [
  //   [41, -114, 207],
  //   [14, -157, 246],
  //   [25, -140, 231],
  //   [34, -124, 217],
  //   [42, -114, 206],
  //   [47, -105, 197],
  //   [52, -97, 187],
  //   [56, -90, 180],
  //   [60, -84, 173],
  //   [63, -79, 169],
  //   [66, -74, 164],
  //   [75, -60, 151],
  //   [81, -51, 144],
  //   [13, -16, 109],
  //   [94, -30, 119]
  // ];
  
//   const predict = createPredictionFunction(data2);
//   console.log(`z = ${predict.toString()}`);


export function getEnumKeyByValue<T extends {[index: string]: string}>(myEnum: T, enumValue: string): keyof T | null {
  const keys = Object.keys(myEnum).filter(x => myEnum[x] === enumValue);
  return keys.length > 0 ? keys[0] as keyof T : null;
}

export function getIsMobileDevice(): boolean {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export function getIsIPhone(): boolean {
  const iosParam = getUrlParam(UrlParams.IOS);
  if (iosParam === 'true' || iosParam === '1') {
    return true;
  }

  const ua = navigator.userAgent;
  if (/iPhone/i.test(ua) && !/iPad/i.test(ua) && !/iPod/i.test(ua)) {
    return true;
  }
  return false;
}

export function getIsAndroid(): boolean {
  const ua = navigator.userAgent;
  if (/Android/i.test(ua)) {
    return true;
  }
  return false;
}

// Function to check if data is available
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isDataAvailable = (data: any): boolean => {
  if (data === null || data === undefined) return false;
  if (Array.isArray(data)) return data.length > 0;
  if (typeof data === 'object') {
      // Check if object has any keys
      const keys = Object.keys(data);
      if (keys.length === 0) return false;
      
      // Check if at least one key has non-empty data
      return keys.some(key => {
          const value = data[key];
          if (value === null || value === undefined) return false;
          if (Array.isArray(value)) {
              // Check if array has elements and if at least one element has data
              return value.length > 0 && value.some(item => isDataAvailable(item));
          }
          if (typeof value === 'object') return isDataAvailable(value);
          return true;
      });
  }
  return true;
};

/**
 * Case-insensitive reverse lookup: finds the object key whose string value equals `value`.
 * Example: map `{"stats":"Statistics","table":"Table"}` with `"statistics"` → `"stats"`.
 */
export const getKeyByValue = (
  object: Record<string, string>,
  value: string,
): string | undefined => {
  const lowercaseValue = value.toLowerCase();
  return Object.keys(object).find((key) => object[key].toLowerCase() === lowercaseValue);
};
